<template lang="pug">
v-container
  v-card
    v-card-text
      h1 TEST
      v-row
        v-col
          app-datetime-picker(v-model="date", :disableTime="timeDisabled")
          v-switch(v-model="timeDisabled")
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      date: "2020-10-25 14:25",
      timeDisabled: true,
    }
  },
  methods: {
    //
  },
  mounted() {
    console.log("test view!!!")
  }
}
</script>